// extracted by mini-css-extract-plugin
module.exports = {"pointinfo":"MarkerMenu_pointinfo__cqoTH","attributes":"MarkerMenu_attributes__1HzXv"};